var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2091 10.3896L15.1946 9.40416C17.0422 7.55642 17.5349 3.24519 16.3647 2.07505C15.1945 0.904915 10.8833 1.39758 9.03563 3.24519L8.0502 4.23067M14.2091 10.3896L14.825 14.7008L12.3614 17.1644L10.5138 14.0849M14.2091 10.3896L10.5138 14.0849M10.5138 14.0849L9.28198 15.3167L7.43429 13.4691M8.0502 4.23067L3.73896 3.61478L1.27539 6.07835L4.35487 7.92603M8.0502 4.23067L4.35487 7.92603M4.35487 7.92603L3.12308 9.15781L4.97076 11.0055",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.6836,
    cy: 6.63403,
    r: 1.6643,
    stroke: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63544 12.1289L1 13.7643",
    stroke: "inherit",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47391 13.9678L1.61389 16.8278M6.31249 15.8064L4.6782 17.4407",
    stroke: "inherit",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPage);
export default __webpack_public_path__ + "static/media/landingPage.0fb83abb.svg";
export { ForwardRef as ReactComponent };